"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTopicUnread = exports.lastContentAt = exports.FORUM_UNREAD_NEVER_OPENED_WINDOW_DAYS = void 0;
/** Topics never opened by the member stay unread only within this window (avoids badge spam on launch). */
exports.FORUM_UNREAD_NEVER_OPENED_WINDOW_DAYS = 14;
var lastContentAt = function (timestamps) {
    var _a;
    var times = [new Date(timestamps.postCreatedAt).getTime()];
    (_a = timestamps.commentCreatedAts) === null || _a === void 0 ? void 0 : _a.forEach(function (createdAt) {
        if (createdAt)
            times.push(new Date(createdAt).getTime());
    });
    return new Date(Math.max.apply(Math, times));
};
exports.lastContentAt = lastContentAt;
var isTopicUnread = function (input) {
    var _a;
    var contentAt = new Date(input.lastContentAt);
    var now = (_a = input.now) !== null && _a !== void 0 ? _a : new Date();
    if (input.lastSeenAt) {
        return contentAt.getTime() > new Date(input.lastSeenAt).getTime();
    }
    var windowStart = new Date(now);
    windowStart.setDate(windowStart.getDate() - exports.FORUM_UNREAD_NEVER_OPENED_WINDOW_DAYS);
    return contentAt.getTime() > windowStart.getTime();
};
exports.isTopicUnread = isTopicUnread;
//# sourceMappingURL=forumUnread.js.map